import React from 'react';
import PropTypes from 'prop-types';

const PlayerSuggestion = ({ model }) => {
    if (!model) return null;

    return (
        <div className="player-suggestion">
            <div className="player-suggestion__firstname">{model.firstName}</div>
            <div className="player-suggestion__lastname">{model.lastName}</div>
        </div>
    );
};

PlayerSuggestion.propTypes = {
    model: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    })
};

export default PlayerSuggestion;
